/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MarketStatisticsItemDto } from './MarketStatisticsItemDto';
import {
    MarketStatisticsItemDtoFromJSON,
    MarketStatisticsItemDtoFromJSONTyped,
    MarketStatisticsItemDtoToJSON,
    MarketStatisticsItemDtoToJSONTyped,
} from './MarketStatisticsItemDto';

/**
 * Response containing market statistics table data
 * @export
 * @interface GetMarketStatisticsResponse
 */
export interface GetMarketStatisticsResponse {
    /**
     * Array of market statistics items
     * @type {Array<MarketStatisticsItemDto>}
     * @memberof GetMarketStatisticsResponse
     */
    items: Array<MarketStatisticsItemDto>;
    /**
     * Total number of items (for pagination)
     * @type {number}
     * @memberof GetMarketStatisticsResponse
     */
    totalCount: number;
    /**
     * Current page number
     * @type {number}
     * @memberof GetMarketStatisticsResponse
     */
    page?: number;
    /**
     * Items per page
     * @type {number}
     * @memberof GetMarketStatisticsResponse
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the GetMarketStatisticsResponse interface.
 */
export function instanceOfGetMarketStatisticsResponse(value: object): value is GetMarketStatisticsResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function GetMarketStatisticsResponseFromJSON(json: any): GetMarketStatisticsResponse {
    return GetMarketStatisticsResponseFromJSONTyped(json, false);
}

export function GetMarketStatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMarketStatisticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MarketStatisticsItemDtoFromJSON)),
        'totalCount': json['totalCount'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetMarketStatisticsResponseToJSON(json: any): GetMarketStatisticsResponse {
    return GetMarketStatisticsResponseToJSONTyped(json, false);
}

export function GetMarketStatisticsResponseToJSONTyped(value?: GetMarketStatisticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MarketStatisticsItemDtoToJSON)),
        'totalCount': value['totalCount'],
        'page': value['page'],
        'pageSize': value['pageSize'],
    };
}

